import { IngestionPlatform } from '@client/graphql/__generated__/types';
import { match } from 'ts-pattern';
import { formatPlatformName } from '~/common/pages/Compliance/utils/platform.utils';

/**
 * Display name for the source platform used in agent-facing copy and CTAs
 * ("Fix in {name}", "Open in {name}"). Platforms whose brand casing differs from
 * the enum's title-case form are spelled out so the agent sees the real product
 * name (SkySlope, ZipForm); the rest fall back to {@link formatPlatformName}.
 */
export const platformDisplayName = (platform: IngestionPlatform): string =>
  match(platform)
    .with(IngestionPlatform.SKYSLOPE, () => 'SkySlope')
    .with(IngestionPlatform.ZIPFORM, () => 'ZipForm')
    .with(IngestionPlatform.KW_COMMAND, () => 'KW Command')
    .otherwise(() => formatPlatformName(platform));

/**
 * The noun for the unit an agent resubmits, used in resubmit copy. SkySlope
 * resubmits act on a whole checklist item; every other platform (Dotloop,
 * ZipForm) resubmits a single document.
 */
export const platformEntityNoun = (platform: IngestionPlatform): string =>
  match(platform)
    .with(
      IngestionPlatform.SKYSLOPE,
      IngestionPlatform.KW_COMMAND,
      () => 'checklist item'
    )
    .otherwise(() => 'document');

/** Whether the agent review should present platform checklist-item semantics. */
export const isChecklistPlatform = (platform: IngestionPlatform): boolean =>
  platform === IngestionPlatform.SKYSLOPE ||
  platform === IngestionPlatform.KW_COMMAND;
